import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Client components recreate these page-specific schemas on mount.
document.querySelectorAll('script[data-prerender-page-schema]:not([data-approved-schema])').forEach((node) => node.remove());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
